let baseUrl = '';

export const getBaseUrl = () => baseUrl;

export const setBaseUrl = (url: string): void => {
	baseUrl = url;
};
